import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ErrorDialogComponent } from 'src/app/components/dialog/error-dialog/error-dialog.component';
import { SuccessDialogComponent } from 'src/app/components/dialog/success-dialog/success-dialog.component';
import { FormaSolicitacao } from 'src/app/model/formaSolicitacao';
import { FormaSolicitacaoService } from 'src/app/service/forma-solicitacao/forma-solicitacao.service';
import { PadraoService } from 'src/app/service/padrao/padrao.service';

@Component({
  selector: 'app-chamado-delegatario',
  templateUrl: './chamado-delegatario.component.html',
  styleUrls: ['./chamado-delegatario.component.css'],
  providers: [PadraoService, MatDialog],
  entryComponents: [SuccessDialogComponent]
})
export class ChamadoDelegatarioComponent implements OnInit {
  
  @BlockUI() loading: NgBlockUI;

  tipoChamadoForm : FormGroup;
  formaSolicitacaoList = new Array<FormaSolicitacao>();

  divCadastroACesso = false;
  divErroFalhaInfo = false;

  validFormaSolicitacao = false;
  mandaTipoChamado : any;


  constructor(
            private formBuilder: FormBuilder, 
            private dialog: MatDialog, 
            private formaSolicitacaoService: FormaSolicitacaoService
            ) { }
  ngAfterViewInit() { }

  ngOnInit() {

    this.tipoChamadoForm = this.formBuilder.group({ tipoChamado:["", Validators.required]});
    this.carregarFormaSolicitacao();
  }


  carregarFormaSolicitacao(): void {
    this.loading.start('Aguarde um momento...');
    this.formaSolicitacaoService.obterListaFormaSolicitacao().subscribe(response => {
      this.formaSolicitacaoList = response;
      this.loading.stop();
    }, (error) => {
      this.loading.stop();
      this.abrirRespostaErro(error);
    });
  }

  carregarDivGrids(solicitacao:any) {
    this.validFormaSolicitacao = true;
    var tipoChamado = solicitacao.descricao 
    this.mandaTipoChamado = solicitacao.descricao; 
    if(tipoChamado ==="CADASTRO / Acesso") {
      this.divCadastroACesso = true; 
      this.divErroFalhaInfo = false;
      
    }else{
      this.divCadastroACesso = false;
      this.divErroFalhaInfo = true;
    }
  }

  abrirRespostaErro(resposta: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { valor: resposta };
    dialogConfig.width = '600px';
    dialogConfig.height = '380px';
    this.dialog.open(ErrorDialogComponent, dialogConfig);
  }

  limparTipoChamado(value) {
    this.limparForm();
  }

  limparForm() {
    this.tipoChamadoForm.get('tipoChamado').setValue('');
    this.validFormaSolicitacao = false;
    this.divCadastroACesso = false;
    this.divErroFalhaInfo = false;
    this.ngOnInit();
  }
}